"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FolderMove = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M20,11 L19,11 L19,8 L5,8 L5,19 L14,19 L14,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 L9.38196601,4 C9.76073807,4 10.1070012,4.21400238 10.2763932,4.5527864 L11.5,7 L19,7 C19.5522847,7 20,7.44771525 20,8 L20,11 Z M5,7 L10.381966,7 L9.38196601,5 L5,5 L5,7 Z M21.2928932,16.9970009 L16,16.9970009 L16,15.9970009 L21.2928932,15.9970009 L19.1479627,13.8534567 C18.9527006,13.6583208 18.9525982,13.3418407 19.1477342,13.1465785 C19.343123,12.9511896 19.6597151,12.9511551 19.8550322,13.1463872 L23.2071068,16.4970009 L19.8548602,19.8510483 C19.6597029,20.0463104 19.3432055,20.0463954 19.1479433,19.8512381 C18.9525635,19.6558583 18.9525004,19.3392583 19.1477076,19.1438957 L21.2928932,16.9970009 Z" })));
};
FolderMove.displayName = 'FolderMove';
exports.default = FolderMove;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FolderMove.js.map